module.exports = __webpack_public_path__ + "static/media/FAVORITOS.38ba4455.svg";